import { render, staticRenderFns } from "./TransferSearch.vue?vue&type=template&id=fa9fde6e&scoped=true"
import script from "./TransferSearch.vue?vue&type=script&lang=js"
export * from "./TransferSearch.vue?vue&type=script&lang=js"
import style0 from "./TransferSearch.vue?vue&type=style&index=0&id=fa9fde6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9fde6e",
  null
  
)

export default component.exports